import { SizableText, XStack } from 'tamagui';

interface MissingFieldsIndicatorProps {
  label: string;
}

export const MissingFieldsIndicator = ({
  label,
}: MissingFieldsIndicatorProps): React.ReactElement => (
  <XStack
    alignSelf="flex-start"
    backgroundColor="$warningBg"
    paddingHorizontal="$2"
    paddingVertical="$1"
  >
    <SizableText size="$3" color="$warningFont">
      {label}
    </SizableText>
  </XStack>
);
